document.addEventListener('DOMContentLoaded', async function() {
  console.log('Brand info section script loaded');
  
  // 确保骨架屏显示
  const skeletonContainer = document.getElementById('brand-skeleton-container');
  if (skeletonContainer) {
    console.log('Setting skeleton container display to flex');
    skeletonContainer.style.display = 'flex';
  } else {
    console.log('Skeleton container not found');
  }
  
  // 获取当前产品的vendor
  const currentVendor = document.querySelector('.brand-title h3')?.textContent.trim();
  console.log('Current vendor:', currentVendor);
  
  // 初始化导航按钮
  initNavButtons();
  
  // 加载品牌信息
  if (currentVendor) {
    try {
      // 获取产品信息
      const vendorInfo = await fetch(`https://service.aoklok.com:3000/admin/vendor/getVendor?vendorName=${currentVendor}`);
      const vendorData = await vendorInfo.json();
      
      if (vendorData.code == 200) {
        // 解析LOGO和视频资源地址
        const vendorInfo = vendorData.data[0];
        const logoUrl = vendorInfo.logo_url;
        const toUrl = vendorInfo.to_url;
        
        // 替换LOGO
        const logoImg = document.getElementById('brand-avatar-img');
        if (logoImg && logoUrl) {
          logoImg.src = "https://service.aoklok.com:3000/admin/vendor/getImage?imagePath=" + logoUrl;  
        }
        
        // 存储跳转URL，用于Follow按钮
        if (toUrl) {
          window.brandToUrl = toUrl;
        }
        
        // 获取当前产品ID并加载品牌产品
        const currentProductId = window.currentProductId || (window.meta && window.meta.product && window.meta.product.id);
        console.log('Current product ID:', currentProductId);
        if (currentProductId) {
          loadBrandProducts(currentProductId);
        } else {
          console.error('Current product ID not found');
          hideSkeletonShowError('Product ID not found');
        }
      }
    } catch (error) {
      console.error("Error loading brand info:", error);
      hideSkeletonShowError('Failed to load brand info');
    }
  } else {
    console.error('Current vendor not found');
    hideSkeletonShowError('Vendor information not found');
  }
  
  // 导航按钮初始化及交互逻辑
  function initNavButtons() {
    const prevButton = document.querySelector('.products-nav-button.nav-prev');
    const nextButton = document.querySelector('.products-nav-button.nav-next');
    const productsRow = document.querySelector('.products-row');
    
    if (!prevButton || !nextButton || !productsRow) {
      console.log('Navigation buttons or products row not found');
      return;
    }
    
    // 初始状态设置
    prevButton.classList.add('disabled');
    
    // 检查滚动位置并更新按钮状态
    function updateButtonStates() {
      const { scrollLeft, scrollWidth, clientWidth } = productsRow;
      
      // 如果在最左侧，禁用前一个按钮
      prevButton.classList.toggle('disabled', scrollLeft <= 0);
      
      // 如果在最右侧，禁用下一个按钮
      nextButton.classList.toggle('disabled', Math.ceil(scrollLeft + clientWidth) >= scrollWidth);
    }
    
    // 滚动到上一组产品
    prevButton.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      
      const scrollAmount = productsRow.clientWidth * 0.8;
      productsRow.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });
    
    // 滚动到下一组产品
    nextButton.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      
      const scrollAmount = productsRow.clientWidth * 0.8;
      productsRow.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });
    
    // 监听滚动事件以更新按钮状态
    productsRow.addEventListener('scroll', updateButtonStates);
    
    // 监听窗口大小变化，以便在调整大小后更新按钮状态
    window.addEventListener('resize', updateButtonStates);
    
    // 初始化按钮状态
    updateButtonStates();
  }
  
  // 函数：获取产品数据
  async function fetchProductData(productId) {
    try {
      // 获取用户首选货币
      const userCurrency = getUserPreferredCurrency();
      
      // 基于币种确定国家代码
      let countryCode = 'US'; // 默认美国
      
      // 基于币种确定国家代码
      switch(userCurrency) {
        case 'CNY':
          countryCode = 'CN';
          break;
        case 'USD':
          countryCode = 'US';
          break;
        case 'EUR':
          countryCode = 'FR'; // 使用法国作为欧元区代表
          break;
        case 'GBP':
          countryCode = 'GB';
          break;
        case 'CAD':
          countryCode = 'CA';
          break;
        case 'AUD':
          countryCode = 'AU';
          break;
        case 'JPY':
          countryCode = 'JP';
          break;
        case 'KRW':
          countryCode = 'KR';
          break;
        case 'HKD':
          countryCode = 'HK';
          break;
        case 'SGD':
          countryCode = 'SG';
          break;
        case 'TWD':
          countryCode = 'TW';
          break;
        case 'RUB':
          countryCode = 'RU';
          break;
        case 'BRL':
          countryCode = 'BR';
          break;
        case 'INR':
          countryCode = 'IN';
          break;
        case 'MXN':
          countryCode = 'MX';
          break;
        case 'PLN':
          countryCode = 'PL';
          break;
        case 'SEK':
          countryCode = 'SE';
          break;
        case 'CHF':
          countryCode = 'CH';
          break;
        default:
          // 对于未知货币代码，尝试将前两个字母作为国家代码
          if (userCurrency && userCurrency.length >= 2) {
            const possibleCountryCode = userCurrency.slice(0, 2).toUpperCase();
            // 检查是否像是合法的国家代码（两个大写字母）
            if (/^[A-Z]{2}$/.test(possibleCountryCode)) {
              countryCode = possibleCountryCode;
            }
          }
      }
      
      console.log(`用户货币为 ${userCurrency}，使用国家代码: ${countryCode}`);
      
      // 修改GraphQL查询，添加@inContext指令
      const response = await fetch(`https://Kclot.myshopify.com/api/2025-01/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "72859f55af4df22334c189753571fd62"
        },
        body: JSON.stringify({
          query: `
            query ProductByHandle($id: ID!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
              product(id: $id) {
                title
                handle
                vendor
                featuredImage { originalSrc }
                priceRange { minVariantPrice { amount currencyCode } }
              }
            }`,
          variables: {
            id: `gid://shopify/Product/${productId}`,
            countryCode: countryCode
          }
        })
      });
      
      const shopifyData = await response.json();
      
      // 确保有产品数据
      if (shopifyData.data && shopifyData.data.product) {
        return shopifyData.data.product;
      } else {
        console.error('No product data found:', shopifyData);
        return null;
      }
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }
  
  // 隐藏骨架屏并显示错误消息
  function hideSkeletonShowError(errorMessage = 'Unable to load products') {
    console.log('Hiding skeleton and showing error:', errorMessage);
    
    const skeletonContainer = document.getElementById('brand-skeleton-container');
    const productsRow = document.querySelector('.products-row');
    
    // 隐藏骨架屏
    if (skeletonContainer) {
      skeletonContainer.style.display = 'none';
    } else {
      console.log('Skeleton container not found in hideSkeletonShowError');
    }
    
    // 显示错误消息
    if (productsRow) {
      // 创建一个新的错误消息元素，而不是直接设置innerHTML
      const errorElement = document.createElement('div');
      errorElement.className = 'brand-error-message';
      errorElement.textContent = errorMessage;
      
      // 先移除所有子元素
      while (productsRow.firstChild) {
        productsRow.removeChild(productsRow.firstChild);
      }
      
      // 添加错误消息
      productsRow.appendChild(errorElement);
    }
    
    // 添加错误消息样式
    const style = document.createElement('style');
    style.textContent = `
      .brand-error-message {
        width: 100%;
        padding: 16px;
        text-align: center;
        color: #666;
        font-size: 14px;
      }
    `;
    document.head.appendChild(style);
  }
  
  // 获取用户首选的货币
  function getUserPreferredCurrency() {
    console.log('开始获取用户首选货币...');
    
    // 首先检查Shopify.currency对象是否存在且有active属性
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      console.log('从Shopify.currency.active获取货币:', Shopify.currency.active);
      return Shopify.currency.active;
    }
    
    // 然后尝试从cookie获取
    let cookieValue = null;
    const cookieMatch = document.cookie.match(/currency=([^;]+)/);
    if (cookieMatch) {
      cookieValue = cookieMatch[1];
      console.log('从cookie获取货币:', cookieValue);
      return cookieValue;
    }
    
    // 再尝试从localStorage获取
    const storedCurrency = localStorage.getItem('preferred_currency');
    if (storedCurrency) {
      console.log('从localStorage获取货币:', storedCurrency);
      return storedCurrency;
    }
    
    // 最后返回默认货币
    const defaultCurrency = "USD"; // 默认使用美元
    console.log('没有找到用户首选货币，使用默认货币:', defaultCurrency);
    return defaultCurrency;
  }
  
  // 格式化价格的函数
  function formatMoney(amount, currencyCode) {
    try {
      const numericAmount = parseFloat(amount);
      if (isNaN(numericAmount)) {
        return '暂无价格';
      }
      
      // 验证货币代码
      if (!currencyCode || typeof currencyCode !== 'string') {
        console.warn('无效的货币代码:', currencyCode);
        currencyCode = getUserPreferredCurrency(); // 使用用户首选货币作为回退
        console.log('使用用户首选货币:', currencyCode);
      }
      
      console.log(`格式化价格: 金额=${numericAmount}, 货币代码=${currencyCode}`);
      
      // 现代浏览器支持Intl.NumberFormat
      if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
        // 根据货币代码选择适合的语言环境
        let locale;
        switch (currencyCode) {
          case 'CNY':
            locale = 'zh-CN';
            break;
          case 'USD':
            locale = 'en-US';
            break;
          case 'EUR':
            locale = 'de-DE';
            break;
          case 'GBP':
            locale = 'en-GB';
            break;
          case 'JPY':
            locale = 'ja-JP';
            break;
          case 'KRW':
            locale = 'ko-KR';
            break;
          case 'CAD':
            locale = 'en-CA';
            break;
          case 'AUD':
            locale = 'en-AU';
            break;
          case 'HKD':
            locale = 'zh-HK';
            break;
          case 'SGD':
            locale = 'en-SG';
            break;
          case 'TWD':
            locale = 'zh-TW';
            break;
          default:
            // 尝试使用货币代码作为国家代码的一部分来确定区域设置
            const countryCode = currencyCode.slice(0, 2);
            locale = `en-${countryCode}`;
        }
        
        try {
          // 尝试使用Intl.NumberFormat，如果失败则使用回退方法
          const formattedPrice = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(numericAmount);
          
          console.log(`格式化后的价格(Intl.NumberFormat): ${formattedPrice}`);
          return formattedPrice;
        } catch (intlError) {
          console.warn('Intl.NumberFormat格式化失败，使用回退方法:', intlError);
          // 如果Intl.NumberFormat失败，使用回退方法
        }
      }
      
      // 回退方法，为不支持Intl.NumberFormat的旧浏览器提供
      // 扩展的货币符号映射
      let symbol = '';
      let position = 'before'; // 'before' 或 'after'
      let decimals = 2;
      
      switch (currencyCode) {
        case 'CNY':
          symbol = '¥';
          break;
        case 'USD':
          symbol = '$';
          break;
        case 'EUR':
          symbol = '€';
          break;
        case 'GBP':
          symbol = '£';
          break;
        case 'JPY':
          symbol = '¥';
          decimals = 0;
          break;
        case 'KRW':
          symbol = '₩';
          decimals = 0;
          break;
        case 'CAD':
          symbol = 'CA$';
          break;
        case 'AUD':
          symbol = 'A$';
          break;
        case 'HKD':
          symbol = 'HK$';
          break;
        case 'SGD':
          symbol = 'S$';
          break;
        case 'TWD':
          symbol = 'NT$';
          break;
        case 'RUB':
          symbol = '₽';
          break;
        case 'BRL':
          symbol = 'R$';
          break;
        case 'INR':
          symbol = '₹';
          break;
        case 'MXN':
          symbol = 'Mex$';
          break;
        case 'PLN':
          symbol = 'zł';
          position = 'after';
          break;
        case 'SEK':
          symbol = 'kr';
          position = 'after';
          break;
        case 'CHF':
          symbol = 'CHF';
          position = 'before';
          break;
        default:
          symbol = currencyCode + ' ';
      }
      
      // 根据货币处理小数位
      let formattedNumber = decimals > 0 ? numericAmount.toFixed(decimals) : Math.round(numericAmount).toString();
      
      // 添加千位分隔符
      formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      
      // 根据位置组合货币符号和金额
      const formattedPrice = position === 'before' ? symbol + formattedNumber : formattedNumber + ' ' + symbol;
      
      console.log(`格式化后的价格(回退方法): ${formattedPrice}`);
      return formattedPrice;
    } catch (error) {
      console.error('价格格式化错误:', error);
      return `${amount} ${currencyCode}`;
    }
  }
  
  // 加载品牌产品函数 - 更新为使用与product-ai-story_bak.liquid相同的API
  async function loadBrandProducts(currentProductId) {
    console.log('Loading brand products for product ID:', currentProductId);
    
    const productsRow = document.querySelector('.products-row');
    const skeletonContainer = document.getElementById('brand-skeleton-container');
    
    if (!productsRow) {
      console.error('Products row not found');
      return;
    }
    
    // 确保骨架屏可见
    if (skeletonContainer) {
      console.log('Making skeleton container visible');
      skeletonContainer.style.display = 'flex';
    } else {
      console.error('Skeleton container not found');
    }
    
    try {
      console.log('Fetching brand products from API');
      // 使用API获取品牌产品（使用与product-ai-story_bak.liquid相同的API）
      const brandRecommendations = await fetch('https://service.aoklok.com:8746/rnss/moreBrandProducts?shopifyId=' + currentProductId);
      const brandRecommendationsData = await brandRecommendations.json();
      console.log('Brand recommendations data:', brandRecommendationsData);
      
      if (brandRecommendationsData && brandRecommendationsData.items && brandRecommendationsData.items.length > 0) {
        console.log(`Found ${brandRecommendationsData.items.length} brand products`);
        
        // 创建一个文档片段来存储所有产品卡片
        const fragment = document.createDocumentFragment();
        const productCards = [];
        
        // 遍历推荐数据
        for (const item of brandRecommendationsData.items) {
          console.log('Fetching product data for item:', item.shopify_id);
          const productData = await fetchProductData(item.shopify_id);
          if (productData) {
            console.log('Product data loaded:', productData.title);
            
            // 获取价格和货币信息
            let formattedPrice = '暂无价格';
            
            // 获取用户首选货币 - 这是关键修改，始终优先使用用户设置的币种
            const userCurrency = getUserPreferredCurrency();
            
            if (productData.priceRange && productData.priceRange.minVariantPrice) {
              const { amount } = productData.priceRange.minVariantPrice;
              if (amount) {
                // 使用用户首选货币格式化价格，而不是API返回的货币
                formattedPrice = formatMoney(amount, userCurrency);
              }
            } else {
              // 如果没有价格信息，使用用户首选货币和零金额
              formattedPrice = formatMoney(0, userCurrency);
            }
            
            // 创建产品卡片元素
            const productCard = document.createElement('div');
            productCard.className = 'product-card';
            productCard.innerHTML = `
              <div class="product-image">
                <img onclick="window.location.href='/products/${productData.handle}'" src="${productData.featuredImage.originalSrc}" 
                     alt="${productData.title}" 
                     loading="lazy"> 
                <div class="price-tag">
                  <span style="color:white;">${formattedPrice}</span>
                </div>
              </div>
            `;
            
            // 将产品卡片存入数组
            productCards.push(productCard);
          }
        }
        
        console.log(`Created ${productCards.length} product cards`);
        
        // 隐藏骨架屏
        if (skeletonContainer) {
          console.log('Hiding skeleton container');
          skeletonContainer.style.display = 'none';
        }
        
        // 清空当前内容
        console.log('Clearing products row');
        productsRow.innerHTML = '';
        
        // 将所有产品卡片添加到片段
        productCards.forEach(card => fragment.appendChild(card));
        
        // 一次性添加所有产品卡片到DOM
        console.log('Appending product cards to products row');
        productsRow.appendChild(fragment);
        
        // 产品加载完成后，重新初始化导航按钮状态
        setTimeout(() => {
          const prevButton = document.querySelector('.products-nav-button.nav-prev');
          const nextButton = document.querySelector('.products-nav-button.nav-next');
          
          if (prevButton && nextButton) {
            prevButton.classList.toggle('disabled', productsRow.scrollLeft <= 0);
            nextButton.classList.toggle('disabled', Math.ceil(productsRow.scrollLeft + productsRow.clientWidth) >= productsRow.scrollWidth);
          }
        }, 100);
        
      } else {
        console.log('No brand products found or empty items array');
        // 隐藏骨架屏
        if (skeletonContainer) {
          skeletonContainer.style.display = 'none';
        }
        
        // 如果没有产品数据，隐藏整个部分
        const brandProducts = document.querySelector('.brand-products');
        if (brandProducts) {
          brandProducts.style.display = 'none';
        }
      }
    } catch (error) {
      console.error("Error loading brand products:", error);
      // 出错时隐藏骨架屏并显示错误信息
      hideSkeletonShowError('Error loading brand products');
      
      // 隐藏整个部分
      const brandProducts = document.querySelector('.brand-products');
      if (brandProducts) {
        brandProducts.style.display = 'none';
      }
    }
  }
}); 